import { COLORS } from '../../../../lib/constants';
import { EXPORT_TYPE, MAP_LAYER_IDS, SIDEBAR_SAVED_TABS, SIDEBAR_VIEWS } from '../../../../lib/constants';
import Alert from '../../../Modals/Alert';
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle';
import Button from '../../../Button';
import Check from '../../../../assets/svg/Feather/Check';
import CornerRightUp from '../../../../assets/svg/Feather/CornerRightUp';
import Download from '../../../../assets/svg/Feather/Download';
import ghAnalytics from '../../../../lib/analytics';
import Trash2 from '../../../../assets/svg/Feather/Trash2';

export default (dispatch) => {
  const exportCollectionFeatures = (collection, format) => () => {
    dispatch({
      type: 'modals/close'
    });

    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Exporting your content...',
        loader: true
      }
    });

    dispatch({
      type: 'features/exportFeatures',
      payload: {
        fileType: format,
        featureIds: collection.featureIds
      },
      callback: (exportId) => {
        if (!exportId) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an error generating your export.',
              icon: AlertCircle,
              iconColor: '#FF3B30',
              dismissable: true
            }
          });
        } else {
          dispatch({
            type: 'features/getExportPoll-start',
            payload: exportId,
            callback: (exportUrl) => {
              dispatch({
                type: 'features/getExportPoll-stop',
              });

              setTimeout(() => {
                if (exportUrl) {
                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Preparing to download...',
                      loader: true
                    }
                  });

                  window.open(exportUrl, '_blank');

                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Click here if download has not started.',
                      icon: Download,
                      dismissable: true,
                      onClick: (e) => {
                        window.open(exportUrl, '_blank');

                        dispatch({
                          type: 'toast/dismiss'
                        });
                      }
                    }
                  });
                } else {
                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'There was an error fetching your export.',
                      icon: AlertCircle,
                      iconColor: '#ff3b30',
                      dismissable: true
                    }
                  });
                }
              }, 3500);
            }
          });
        }
      }
    });
  };

  const deleteCollection = (uuid) => () => {
    dispatch({
      type: 'modals/close',
    });

    dispatch({
      type: 'toast/show',
      payload: {
        loader: true,
        text: 'Deleting hunt...',
      },
    });

    dispatch({
      type: 'collections/deleteCollectionEffect',
      payload: uuid,
      callback: (collection) => {
        if (collection) {
          ghAnalytics.logCollectionDeleted(collection);
        }

        dispatch({
          type: 'toast/show',
          payload: {
            text: 'Hunt deleted',
            icon: Trash2,
          },
        });

        dispatch({
          type: 'collections/setCollectionsLoading',
          payload: false,
        }),

        dispatch({
          type: 'app/gotoSidebar',
          payload: {
            view: SIDEBAR_VIEWS.Content,
            metadata: {
              tab: SIDEBAR_SAVED_TABS.Collection,
            },
          },
        });

        setTimeout(() => {
          dispatch({
            type: 'toast/dismiss',
          });
        }, 3500);
      },
    });
  };

  const leaveShare = (collection) => {
    dispatch({
      type: 'share/leaveShare',
      payload: {
        grantableType: 'collections',
        grantableId: collection.uuid
      },
      callback: success => {
        if (success) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'You have succesfully left the shared hunt.',
              icon: Check,
              iconColor: COLORS.ghOrange
            }
          });
      
          setTimeout(() => {
            dispatch({
              type: 'toast/dismiss'
            });
          }, 3500);
          dispatch({
            type: 'map/removeMultipleFeatureGraphicsById',
            payload: {
              featureIds: collection.featureIds,
              layerId: MAP_LAYER_IDS.content
            }
          });    
          dispatch({
            type: 'features/deleteFeaturesFromUserData',
            payload: collection.featureIds
          });
          dispatch({
            type: 'collections/deleteHuntFromUserData',
            payload: collection.uuid,
          });
          dispatch({
            type: 'collections/setCollectionsLoading',
            payload: false,
          }),
          dispatch({
            type: 'app/gotoSidebar',
            payload: {
              view: SIDEBAR_VIEWS.Content,
              metadata: {
                tab: SIDEBAR_SAVED_TABS.Collection,
              },
            },
          });
        } else {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an issue leaving the shared hunt.',
              icon: AlertCircle,
              iconColor: COLORS.errorRed,
              dismissable: true
            }
          });
        }
      }
    });
  };

  return {
    showDeleteModal: (uuid) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            title: 'Delete hunt?',
            subtitle: 'Your map content will not be deleted.',
            message: 'All notes associated with this Hunt will be deleted. If this Hunt is shared, all collaborators will be removed and lose access to it.',
            actionItems: [
              {
                title: 'Delete',
                onClick: deleteCollection(uuid),
              },
              {
                title: 'Cancel',
                theme: Button.THEME.solidSecondary,
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                },
              },
            ],
          },
        },
      });
    },
    showExportModal: (collection) => {
      const collectionVal = collection;
      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            icon: CornerRightUp,
            title: 'Export features from hunt',
            subtitle: 'Choose the file format for your export',
            actionItems: [
              {
                title: 'GPX (.gpx)',
                onClick: exportCollectionFeatures(collectionVal, EXPORT_TYPE.GPX),
              },
              {
                title: 'KML (.kml)',
                onClick: exportCollectionFeatures(collectionVal, EXPORT_TYPE.KML),
              },
              {
                title: 'Cancel',
                theme: Button.THEME.solidSecondary,
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                },
              },
            ],
          },
        },
      });
    },
    toggleEditCollection: () => {
      dispatch({ type: 'collections/toggleEditingCollection' });
    },
    setPinnedCollection: (value) => {
      dispatch({
        type: 'collections/setPinnedCollection',
        payload: value
      });
    },
    setInitialCollectionName: (title) => {
      dispatch({
        type: 'collections/setNewCollectionTitle',
        payload: title,
      });
    },
    showLeftShare: (collection) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            title: 'Leave hunt?',
            actionItems: [
              {
                title: 'Leave',
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                  leaveShare(collection);
                },
              },
              {
                title: 'Cancel',
                theme: Button.THEME.white,
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                },
              },
            ],
          },
        },
      });
    }
  };
};
